import React from 'react';
import Sidebar from './Sidebar';

function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = React.useState(true);

  const mainStyle = {
    marginLeft: sidebarOpen ? '250px' : '60px',
    transition: 'margin-left 0.3s ease-in-out',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '20px'
  };

  return (
    <div>
      <Sidebar onToggle={setSidebarOpen} />
      <main style={mainStyle}>
        {children}
      </main>
    </div>
  );
}

export default Layout;